import { createPostAPI } from '@cuemath/rest-api';
import { BASE_URL } from 'constants/api';

const { usePost: useStudentCourseDowngradePost } = createPostAPI({
  getURL: (_, { studentCourseId }) =>
    `${BASE_URL}/student-course-downgrade/${studentCourseId}`,
});

export { useStudentCourseDowngradePost };
